module.exports = __webpack_public_path__ + "static/media/workano-dark-fa.caf4c000.svg";